import { render, staticRenderFns } from "./denied-partnership-details-widget.vue?vue&type=template&id=1e02f5e1&"
import script from "./denied-partnership-details-widget.vue?vue&type=script&lang=js&"
export * from "./denied-partnership-details-widget.vue?vue&type=script&lang=js&"
import style0 from "./denied-partnership-details-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports